import ReactGA from 'react-ga';

export const ANALYTICS_TRACK_CODE = 'UA-238354295-1';

export const useAnalyticsEventTracker = (category: string) => {
  return (action:string, label?:string) => {
    ReactGA.event({ category, action, label });
  };
};